"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * NOTE(riya-faire): manually pulled this icon from https://www.figma.com/design/znoa0LanYjcmBzokrInq40/GWF---Holiday-Spend-Challenge?node-id=10246-98501&m=dev
 * @optimized using svgo:^3.0.2
 */
export const Twinkle = createSVGIcon(
  <path
    fill="currentColor"
    d="M16 8.5c-6 1.104-6.896 2-8 8-1.104-6-2-6.896-8-8 6-1.104 6.896-2 8-8 1.104 6 2 6.896 8 8"
  />,
  "GrowWithFaireTwinkle",
  {
    viewBox: "0 0 16 17",
    fill: "none",
    color: Core.icon.primary,
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
